import React, { useEffect, useState } from "react";
import useAuth from "../../config/AuthContext";
import Header from "../../components/header/Header";
import WeHandCraftLogo from "../../assets/img/weHandCraftLogoWithoutBg.png";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [first_name, setFirstName] = useState("");
  const [last_name, setLastName] = useState("");
  const [phone_number, setPhoneNumber] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(true);
  const { register } = useAuth();

  useEffect(() => {
    setLoading(false);
  }, []);

  const handleRegister = () => {
    register(first_name, last_name, email, password, phone_number);
  };

  return (
    <>
      <Header hideLogin={true} />
      <div id="registration-page" className="flex h-screen w-screen">
        <div
          id="registration-form-container"
          className="flex flex-1 items-center justify-center min-h-screen"
        >
          <div className="px-8 py-6 w-120 mt-4 text-left bg-white">
            <h3 className="text-2xl font-bold">Create new Account!</h3>
            <div className="mt-3">
              <div className="grid grid-cols-2 gap-2">
                <div>
                  <label className="block" htmlFor="first_name">
                    First Name
                  </label>
                  <input
                    type="text"
                    placeholder="First Name"
                    className="w-full px-4 py-2 mt-1 border rounded-md focus:outline-none"
                    onChange={(e) => setFirstName(e.target.value)}
                  />
                </div>
                <div>
                  <label className="block" htmlFor="last_name">
                    Last Name
                  </label>
                  <input
                    type="text"
                    placeholder="Last Name"
                    className="w-full px-4 py-2 mt-1 border rounded-md focus:outline-none"
                    onChange={(e) => setLastName(e.target.value)}
                  />
                </div>
              </div>
              <div className="mt-3">
                <label className="block" htmlFor="email">
                  Email
                </label>
                <input
                  type="text"
                  placeholder="Email"
                  className="w-full px-4 py-2 mt-1 border rounded-md focus:outline-none"
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div className="mt-3">
                <label className="block">Password</label>
                <input
                  type="password"
                  placeholder="Password"
                  className="w-full px-4 py-2 mt-1 border rounded-md focus:outline-none"
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
              <div className="mt-3">
                <label className="block">Phone Number</label>
                <input
                  type="tel"
                  placeholder="Phone Number"
                  className="w-full px-4 py-2 mt-1 border rounded-md focus:outline-none"
                  onChange={(e) => setPhoneNumber(e.target.value)}
                />
              </div>
              <div className="flex items-baseline mb-4 justify-between">
                <button
                  className="flex-1 px-6 py-2 mt-4 text-white bg-weHandCraftPrimary rounded-lg hover:bg-blue-900"
                  onClick={handleRegister}
                >
                  Register
                </button>
              </div>
              <div className="flex justify-end">
                <a
                  href="/login"
                  className="text-sm text-blue-600 hover:underline"
                >
                  Already have an account?
                </a>
              </div>
            </div>
          </div>
        </div>
        <div
          id="img-container"
          className="flex flex-1 border-2 border-r justify-center items-center md:flex-col mb-10 md:mb-0"
        >
          <img src={WeHandCraftLogo} alt="logo" className=" h-32 md:h-56" />
          <h1 className="text-3xl md:text-4xl text-we-hand-craft-blue font-bold italic">
            We-Handcraft
          </h1>
        </div>
      </div>
    </>
  );
};

export default Login;
